import PropTypes from 'prop-types';

const isHex = str => (/^[0-9A-F]+$/i).test(str)

const intentMapping = {
    expand: { variant: 'regular', kind: 'square-plus' },
    collapse: { variant: 'regular', kind: 'square-minus' },
    view: 'eye',
    edit: 'pencil',
    close: 'close',
    save: 'save',
    load: { variant: 'regular', kind: 'folder-open' },
    delete: 'trash-can',
    print: 'print',
    copy: 'copy',
    search: 'search',
    marker: 'location-dot',
    filter: 'filter',
    add: 'plus',
    sortDown: 'sort-down',
    sortUp: 'sort-up',
    sort: 'sort',
    move: 'up-down-left-right',
    download: 'download',
    upload: 'upload',
    left: 'chevron-left',
    right: 'chevron-right',
    up: 'chevron-up',
    down: 'chevron-down',
    clear: 'arrows-rotate',
    info: 'info-circle',
    locked: 'lock',
    unlocked: 'unlock',
    settings: 'gears',
    group: 'object-group',
    ungroup: 'object-ungroup',
    send: { variant: 'regular', kind: 'paper-plane' },
    preview: 'file-invoice',
    check: 'check',
    previous: 'chevron-left',
    next: 'chevron-right',
    repeat: 'rotate-right',
    ok: 'check',
    submit: 'check',
    cancel: 'xmark',
    apply: 'check',
    attachment: 'paperclip',
    select: { variant: 'regular', kind: 'hand-pointer' },
    guide: 'circle-question',
    back: 'chevron-left',
    popout: 'arrow-up-right-from-square',
    pin: 'thumbtack',
    unpin: 'thumbtack-slash',
    clock: 'clock', 
}

/**
 * An asbtraction of an icon to isolate use of FontAwesome
 * @component
 */
const Icon = ({ intent, literal, variant, kind, style }) => {
    if (intent) {
        if (intentMapping[intent] === undefined) {
            throw new Error(`Unknown icon intent ${intent}`);
        }
        const info = intentMapping[intent];
        if (typeof info === 'string') {
            variant = 'solid';
            kind = info;
        } else {
            variant = info.variant ?? 'solid';
            kind = info.kind;
        }
    }

    if ((!literal && (!variant && !kind))
        || (variant && !kind) || (kind && !variant)) {
        return <i></i>;
    }

    if (literal) {
        if (isHex(literal)) {
            return <i className="fas" style={style}>{String.fromCodePoint(parseInt(literal, 16))}</i>
        } else {
            return <i className={literal} style={style}></i>
        }
    }
    if (!kind.startsWith('fa-')) {
        kind = 'fa-' + kind;
    }

    return <i className={`fa-${variant} ${kind}`} style={style}></i>
}

Icon.propTypes = {
    intent: PropTypes.string,
    literal: PropTypes.string,
    variant: PropTypes.oneOf(['solid', 'regular', 'brands']),
    kind: PropTypes.string,
    style: PropTypes.object
}

export default Icon;